import { useTour as useTour$1 } from '@reactour/tour';

const useTour = () => {
  return useTour$1();
};

export { useTour };
